export const EMPTY_PIN_ENTRY_FIELD = '';